import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-create',
  templateUrl: './breadcrumb-create.component.html',
  styleUrls: ['./breadcrumb-create.component.scss']
})
export class BreadcrumbCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
